import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import * as GraphAPI from "../api/graph-api";
import { format } from "date-fns";
import frLocale from "date-fns/locale/fr";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";

interface IGraphOrigDestEvolutionProps extends WithTranslationLangProps {
  dataKeysDef?: { key: string; label: string }[];
  evolutionData?: GraphAPI.ODAnneeData<GraphAPI.GraphODEvolutionData>[];
  rangeSelectedYears?: number[];
}

class GraphOrigDestEvolution extends React.Component<IGraphOrigDestEvolutionProps> {
  private getAxisValueLabel(dataObj: GraphAPI.GraphODEvolutionData): string {
    return format(dataObj.month, "MMM yy", { locale: frLocale });
  }

  render() {
    if (this.props.evolutionData && this.props.dataKeysDef && this.props.rangeSelectedYears) {
      let minYear = Math.min(...this.props.rangeSelectedYears) + 2000;
      let maxYear = Math.max(...this.props.rangeSelectedYears) + 2000;
      let evolutionData: GraphAPI.GraphODEvolutionData[] = [];
      for (let i = this.props.evolutionData.length - 1; i >= 0; i--) {
        for (let j = minYear; j < maxYear + 1; j++) {
          if (this.props.evolutionData[i].year === j.toString()) {
            evolutionData = evolutionData.concat(this.props.evolutionData[i].data);
            break;
          }
        }
      };
      return (
        <>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={evolutionData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey={this.getAxisValueLabel} />
              <YAxis
                width={50}
                domain={[
                  (dataMin: any) => Math.max(0, Math.floor(dataMin) - 5),
                  100,
                ]}
              >
                <Label
                  angle={-90}
                  value={this.props.t("chart_legend_reliability")}
                  position="insideLeft"
                  style={{ textAnchor: "middle" }}
                />
              </YAxis>
              <Tooltip
                formatter={(value, _name, _props) =>
                  Number(value).toFixed(2) + "%"
                }
              />
              <Legend wrapperStyle={{ position: "relative", bottom: "35px" }} />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[0].key}
                name={this.props.dataKeysDef[0].label}
                stroke="#24356d"
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[1].key}
                name={this.props.dataKeysDef[1].label}
                stroke="#9cc5c4"
                strokeWidth={2}
                strokeDasharray="5 2"
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </>
      );
    }
  }
}

export default withTranslation()(GraphOrigDestEvolution);
